import React, {FC} from "react";
import {useIntl} from "react-intl";
import {PageTitle} from "../../../_metronic/layout/core";
import WareHouseReport from "./WareHouseReport";

const WareHouseReportWrapper: FC = () => {
  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Tình trạng tồn kho & Công nợ</PageTitle>
      <WareHouseReport />
    </>
  )
}
export default WareHouseReportWrapper;